/**
 * 목록에서 끌어낸 것이 무엇인지를 드래그에 싣는 방법.
 *
 * `dragover` 중에는 브라우저가 실은 내용을 읽지 못하게 막고 `types` 만 보여준다. 그래서
 * 표 안에서만 오가는 드래그는 ref 로 들고 다녀도 되지만, 사이드바처럼 다른 컴포넌트가
 * 받는 자리에서는 그럴 수 없다 — 놓는 순간에는 읽을 수 있으므로 여기 실어 보낸다.
 */
export const ENTRY_DRAG_TYPE = 'application/x-arthur-entries'

export interface EntryDrag {
  /** 끌어낸 곳의 root. */
  rootId: string
  /** 그 root 안에서 지금 보고 있던 폴더. */
  path: string
  names: string[]
}

export function packEntryDrag(transfer: DataTransfer, payload: EntryDrag): void {
  transfer.setData(ENTRY_DRAG_TYPE, JSON.stringify(payload))
}

/** 놓는 순간에만 읽을 수 있다. 형태가 다르면 우리 것이 아니다. */
export function unpackEntryDrag(transfer: DataTransfer): EntryDrag | null {
  const raw = transfer.getData(ENTRY_DRAG_TYPE)
  if (raw === '') return null

  try {
    const parsed = JSON.parse(raw) as Partial<EntryDrag>
    if (typeof parsed.rootId !== 'string' || typeof parsed.path !== 'string') return null
    if (!Array.isArray(parsed.names) || parsed.names.length === 0) return null
    return { rootId: parsed.rootId, path: parsed.path, names: parsed.names }
  } catch {
    return null
  }
}

export function carriesEntries(transfer: DataTransfer): boolean {
  return transfer.types.includes(ENTRY_DRAG_TYPE)
}

/**
 * 누른 채로 놓으면 옮기는 대신 복사한다. macOS 는 ⌥, Windows 는 Ctrl 이 그 자리이고,
 * 둘 다 받는다 — 어느 쪽 습관으로 눌러도 뜻이 통해야 한다.
 */
export function wantsCopy(event: { altKey: boolean; ctrlKey: boolean }): boolean {
  return event.altKey || event.ctrlKey
}
